export const ExperienceData = [
    {
        "id": 7,
        "nom": "Extia - Orange",
        "duree": "6 mois - en cours",
        "intitule": "Injection de données en masse dans les différents SI d'Orange et développement d'applications",
        "ville": "Nantes",
        "poste": "Ingénieur FTTH"
    },
    {
        "id": 6,
        "nom": "Operis",
        "duree": "6 mois",
        "intitule": "Gestion d'un grand nombre de tickets sur divers sujets: mise en production, erreur d'affichage, BD corrompue, erreurs fonctionnelles",
        "ville": "Orvault",
        "poste": "Technicien support logiciel"
    },
    {
        "id": 5,
        "nom": "ERT",
        "duree": "3 mois",
        "intitule": "Mise a jour de BD cartographiques, resolution de tickets, manipulation de GIS lies au domaine de la fibre optique et l'urbanisme",
        "ville": "Saint-Herblain",
        "poste": "Dessinateur-projeteur fibre optique"
    },
    {
        "id": 4,
        "nom": "Stage Artelia Ville et Transport",
        "duree": "7 mois",
        "intitule": "Creation d'une methode d'evaluation des fonctionnalites des zones humides, Realisation de rapport pedologique et ecologique",
        "ville": "Saint-Herblain",
        "poste": "Charge de mission zones humides"
    },
    {
        "id": 3,
        "nom": "Service civique LPO ile de re",
        "duree": "4 mois",
        "intitule": "Animation culturelle, realisation d'etudes ecologique en lien avec differents laboratoires de recherches et entretien de la reserve naturelle",
        "ville": "Saint-Clement-des-Baleines",
        "poste": "Charge de mission biodiversite"
    },
    {
        "id": 2,
        "nom": "Museum d'histoire naturelle de Toulouse",
        "duree": "2 ans",
        "intitule": "Animation du museum, passerelle entre les collections et les usagers. Encadrement de groupes, ecoles, anglophones, familles",
        "ville": "Toulouse",
        "poste": "Mediateur scientifique et culturel"
    },
    {
        "id": 1,
        "nom": "McDonald's",
        "duree": "1 an",
        "intitule": "Charge d'accueil clientele, cuisinier, entretien des locaux",
        "ville": "Montaudran",
        "poste": "Equipier polyvalant"
    }
]  
